// useWizardConfig.js
import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { storage, firestore, auth }  from "../firebase/firebase.js";


export function useWizardConfig() {
  const [config, setConfig] = useState(null);
  useEffect(() => {
    (async () => {
      const snap = await getDoc(doc(firestore, 'wizardConfigs', 'steps'));
      if (snap.exists()) setConfig(snap.data());
    })();
  }, []);
  return config;
}
